var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOn = function SvgStarOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.186 15.098a.4.4 0 0 0-.372 0l-4.387 2.306a.4.4 0 0 1-.58-.422l.838-4.884a.4.4 0 0 0-.115-.354l-3.55-3.46a.4.4 0 0 1 .223-.682l4.904-.712a.4.4 0 0 0 .301-.22l2.193-4.443a.4.4 0 0 1 .718 0l2.193 4.444a.4.4 0 0 0 .301.219l4.904.712a.4.4 0 0 1 .222.683l-3.549 3.459a.4.4 0 0 0-.115.354l.838 4.884a.4.4 0 0 1-.58.422l-4.387-2.306Z",
    fill: "#2F5EA7"
  })));
};
export default SvgStarOn;